import { useState } from "react";
import "../styles/Sidebar.css";
import Drawer from "@mui/material/Drawer";
import {
  sidebar_home,
  sidebar_mood_monitor,
  sidebar_journal,
  sidebar_stella,
  UWC_logo,
  UWC_QR,
  my_library,
} from "../assets";
import { useNavigate, useParams } from "react-router-dom";

const SidebarMobile = () => {
  const navigate = useNavigate();
  const { id, urlTitle } = useParams();
  let homeLink = "";
  let linksData = JSON.parse(sessionStorage.getItem("courseInternalLinks"));
  if (linksData !== undefined && linksData !== null) {
    homeLink = linksData.filter((item) => item.name == "Home");
  } else {
    if (
      id !== null &&
      id !== undefined &&
      id !== "" &&
      urlTitle !== null &&
      urlTitle !== undefined &&
      urlTitle !== ""
    ) {
      let linksData = [
        { name: "Home", uri: `/course-internal/${id}/${urlTitle}` },
        { name: "My Journal", uri: `/course-internal/module/my-journal/:id` },
      ];
      sessionStorage.setItem("courseInternalLinks", JSON.stringify(linksData));
      homeLink = [{ name: "Home", uri: `/course-internal/${id}/${urlTitle}` }];
    }
  }
  const [openDrawer, setOpenDrawer] = useState(false);
  const toolsData = [
    // {
    //   img: sidebar_home,
    //   text: "Home",
    //   link: homeLink[0].uri,
    // },
    // {
    //   img: sidebar_stella,
    //   text: "Talk to Stella",
    //   link: "/stella",
    // },
    {
      img: sidebar_mood_monitor,
      text: "Mood Monitor",
      link: "/course-internal/module/mood-monitor",
    },
    // {
    //   img: sidebar_journal,
    //   text: "My Journal",
    //   link: "/course-internal/module/my-journal/:id",
    // },

    {
      img: my_library,
      text: "My Library",
      link: "/course-internal/library",
    },
  ];
  return (
    <>
      <section className="sidebar--mobile align-item-center bg-white">
        <button onClick={() => {
          navigate(homeLink[0].uri)
        }}>Home</button>
        <div></div>
        <button onClick={() => setOpenDrawer(true)}>Tools</button>
      </section>

      <Drawer
        anchor={"bottom"}
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        className="navbar--tools"
      >
        <div className="navbar--tools__container">
          <div></div>
          {toolsData?.map((item, i) => (
            <div
              key={i}
              className="sidebar-li"
              onClick={() => {
                navigate(item.link);
              }}
            >
              <img
                src={item.img}
                className="sidebar-img"
                alt=""
                loading="lazy"
              />
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </Drawer>
    </>
  );
};

export default SidebarMobile;
